/**
 * Call Flutter channel with payload
 * @param {string} channel - The channel name
 * @param {Object} payload - The payload to send
 */
const flutterChannelCall = (channel, payload) => {
  console.log("channel, payload", channel, payload);
  console.log(JSON.stringify({ channel, payload }));

  if (window.flutter_inappwebview) {
    window.flutter_inappwebview
      .callHandler(channel, payload)
      .then((result) => {
        console.log("Flutter handler result:", JSON.stringify(result));
      })
      .catch((error) => {
        console.error("Error calling Flutter handler:", error);
      });
  } else {
    console.warn("Flutter InAppWebView is not available.");
  }
};

/**
 * Get cart ID from cookie
 * @returns {string|null} Cart ID or null if not found
 */
const getCartIdFromCookie = () => {
  const cartCookie = readCookie("cart");
  if (cartCookie === null || cartCookie === undefined) return null;
  const decoded = decodeURIComponent(cartCookie);
  if (decoded === null || decoded === undefined) return null;
  const [cartId] = decoded.split("?");
  if (cartId === null || cartId === undefined) return null;
  return cartId;
};

/**
 * Read cookie by name
 * @param {string} name - Cookie name
 * @returns {string|null} Cookie value or null if not found
 */
const readCookie = (name) => {
  try {
    const cookie = document.cookie.split("; ").find((row) => row.startsWith(`${name}=`));
    if (cookie) {
      return cookie.split("=")[1] || null;
    }
    return null;
  } catch (error) {
    console.error(`Error reading cookie ${name}`, error);
    return null;
  }
};
